import { isBrowser, isDev } from '../../utils/conditions';

interface ZpayHandler {
  onMessage: (message: string, targetOrigin: string) => void;
  handleBackClick: () => boolean;
  handleCloseClick: () => boolean;
}

export const zpayHandler = <T extends keyof ZpayHandler, H extends ZpayHandler>(name: T, callback: H[T]) => {
  if (!isBrowser()) {
    return console.warn(`Should invoke zpayHandler.${name} in client`);
  }

  const _window: any = window;
  const zpayHandler: H = _window.zpayHandler;
  if (!zpayHandler && !isDev()) {
    return console.warn('Should call injectZpayHandler before zpayHandler');
  }

  zpayHandler[name] = callback;
};
